export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9683.79fd51ab.jpg";